(function () {
  var STORAGE_KEY = "bb_cart_discount";

  function normalise(code) {
    return (code || "").trim();
  }

  function discountUrl(code) {
    code = normalise(code);
    return code ? "/checkout?discount=" + encodeURIComponent(code) : "/checkout";
  }

  function drawer() {
    return document.getElementById("CartDrawer");
  }

  function discountInput(root) {
    if (!root) return null;

    return (
      root.querySelector('input[name="discount"]') ||
      root.querySelector('input[name*="discount"]') ||
      root.querySelector('input[placeholder*="discount" i]') ||
      root.querySelector('input[aria-label*="discount" i]')
    );
  }

  function checkoutLink(root) {
    if (!root) return null;

    return (
      root.querySelector("#CartDrawer-CheckoutLink") ||
      root.querySelector('a[href="/checkout"]') ||
      root.querySelector('button[name="checkout"]')
    );
  }

  function msgEl(root) {
    return root ? root.querySelector("#BB-DiscountMsg") : null;
  }

  function setMsg(root, text, type) {
    var el = msgEl(root);
    if (!el) return;

    el.textContent = text || "";
    el.style.display = text ? "block" : "none";

    el.classList.remove("bb-discount-success", "bb-discount-error");

    if (type === "success") el.classList.add("bb-discount-success");
    if (type === "error") el.classList.add("bb-discount-error");
  }

  function saveCode(code) {
    code = normalise(code);

    if (code) {
      localStorage.setItem(STORAGE_KEY, code);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  function getSavedCode() {
    return normalise(localStorage.getItem(STORAGE_KEY));
  }

  function updateCheckoutLink() {
    var d = drawer();
    if (!d) return;

    var input = discountInput(d);
    var inputCode = input ? normalise(input.value) : "";
    var savedCode = getSavedCode();
    var code = inputCode || savedCode;

    var link = checkoutLink(d);
    if (!link) return;

    var url = discountUrl(code);

    if (link.tagName === "A") {
      link.setAttribute("href", url);
    } else {
      link.setAttribute("data-discount-checkout-url", url);
    }

    if (code) {
      link.setAttribute("data-has-discount", "true");
    } else {
      link.removeAttribute("data-has-discount");
    }
  }

  function applyCode(e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;

    var input = discountInput(d);
    if (!input) return;

    var applyBtn =
      e.target.closest("[data-discount-apply]") ||
      e.target.closest('button[name="apply"]') ||
      e.target.closest('.ks-cart-discount-form button[type="submit"]') ||
      e.target.closest(".ks-cart-discount-form button");

    if (!applyBtn) return;

    var sameForm =
      input.closest("form") &&
      applyBtn.closest("form") &&
      input.closest("form") === applyBtn.closest("form");

    var wrap =
      input.closest(".ks-cart-discount-form") ||
      input.closest(".ks-cart-discount") ||
      input.parentElement;

    var sameWrap = wrap && wrap.contains(applyBtn);

    if (!sameForm && !sameWrap) return;

    e.preventDefault();
    e.stopPropagation();

    var code = normalise(input.value);

    if (!code) {
      saveCode("");
      updateCheckoutLink();
      setMsg(d, "Please enter a discount code.", "error");
      return;
    }

    saveCode(code);
    updateCheckoutLink();

    setMsg(
      d,
      "Code saved — your discount will show at checkout.",
      "success"
    );
  }

  function handleSubmit(e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;

    var input = discountInput(d);
    if (!input || !e.target.contains(input)) return;

    e.preventDefault();
    e.stopPropagation();

    var code = normalise(input.value);

    if (!code) {
      saveCode("");
      updateCheckoutLink();
      setMsg(d, "Please enter a discount code.", "error");
      return;
    }

    saveCode(code);
    updateCheckoutLink();

    setMsg(
      d,
      "Code saved — your discount will show at checkout.",
      "success"
    );
  }

  function handleCheckoutClick(e) {
    var d = drawer();
    if (!d) return;

    var checkout = e.target.closest("#CartDrawer-CheckoutLink");
    if (!checkout) return;

    var input = discountInput(d);
    var inputCode = input ? normalise(input.value) : "";
    var savedCode = getSavedCode();
    var code = inputCode || savedCode;

    if (!code) return;

    saveCode(code);

    var url = discountUrl(code);

    e.preventDefault();
    e.stopPropagation();

    window.location.href = url;
  }

  function restoreSavedCode() {
    var d = drawer();
    if (!d) return;

    var input = discountInput(d);
    var savedCode = getSavedCode();

    if (input && savedCode && !normalise(input.value)) {
      input.value = savedCode;
    }

    updateCheckoutLink();
  }

  document.addEventListener("input", function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;

    if (e.target === discountInput(d)) {
      saveCode(e.target.value);
      updateCheckoutLink();
      setMsg(d, "", "");
    }
  });

  document.addEventListener("click", applyCode, true);
  document.addEventListener("submit", handleSubmit, true);
  document.addEventListener("click", handleCheckoutClick, true);

  document.addEventListener("DOMContentLoaded", restoreSavedCode);
  document.addEventListener("cart:refresh", restoreSavedCode);
  document.addEventListener("cart:updated", restoreSavedCode);

  setTimeout(restoreSavedCode, 500);
})();